/**
 * @fileoverview Servicio para gestión de pólizas
 * @description Maneja todas las peticiones HTTP relacionadas con pólizas
 */

import { API_BASE_URL, defaultConfig, handleResponse, buildApiUrl, API_ENDPOINTS } from '../config/api';

/**
 * Servicio para gestión de pólizas
 */
export const polizaService = {
  /**
   * Crea una nueva póliza
   * @param data - Datos de la póliza
   * @returns Promise con la respuesta del servidor
   */
  async crearPoliza(data: any) {
    const response = await fetch(buildApiUrl(API_ENDPOINTS.POLIZA), {
      method: 'POST',
      ...defaultConfig,
      body: JSON.stringify(data),
    });
    
    return handleResponse(response);
  },

  /**
   * Obtiene una póliza por ID
   * @param id - ID de la póliza
   * @returns Promise con los datos de la póliza
   */
  async obtenerPoliza(id: number) {
    const response = await fetch(`${API_BASE_URL}/formulario/poliza/${id}`, {
      method: 'GET',
      ...defaultConfig,
    });
    return handleResponse(response);
  },

  /**
   * Actualiza una póliza existente
   * @param id - ID de la póliza
   * @param data - Datos actualizados
   * @returns Promise con la respuesta del servidor
   */
  async actualizarPoliza(id: number, data: any) {
    const response = await fetch(`${API_BASE_URL}/formulario/poliza/${id}`, {
      method: 'PUT',
      ...defaultConfig,
      body: JSON.stringify(data),
    });
    
    return handleResponse(response);
  },

  /**
   * Elimina una póliza
   * @param id - ID de la póliza
   * @returns Promise con la respuesta del servidor
   */
  async eliminarPoliza(id: number) {
    const response = await fetch(`${API_BASE_URL}/formulario/poliza/${id}`, {
      method: 'DELETE',
      ...defaultConfig,
    });
    return handleResponse(response);
  }
};
